// This allows us to load Angular components on legacy server-side pages.
import {
  Compiler,
  Component,
  HostBinding,
  Injector,
  NgModuleFactory,
  OnInit,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { components } from './components';

@Component({
  selector: 'webapp-compat',
  template: `
    <ng-container #entryPoint></ng-container>
    <router-outlet></router-outlet>
  `,
})
export class CompatComponent implements OnInit {
  @ViewChild('entryPoint', { read: ViewContainerRef, static: true })
  entryPoint: ViewContainerRef;

  @HostBinding('class')
  readonly class = 'WebappCompatWrapper';

  constructor(
    private compiler: Compiler,
    @SkipSelf() private injector: Injector,
  ) {}

  ngOnInit() {
    components
      // Only bootstrap the components on the page
      .filter(({ selector }) => document.getElementsByTagName(selector)[0])
      .forEach(componentItem => {
        componentItem
          .loadModule()
          .then(loadedModule =>
            loadedModule instanceof NgModuleFactory
              ? // use it if it's compiled (aot)
                Promise.resolve(loadedModule)
              : // and compile it if it's not (jit)
                this.compiler.compileModuleAsync(loadedModule),
          )
          .then((ngModuleFactory: NgModuleFactory<unknown>) => {
            const componentFactory = ngModuleFactory
              .create(this.injector)
              .componentFactoryResolver.resolveComponentFactory(
                componentItem.component,
              );
            this.entryPoint.createComponent(
              componentFactory,
              componentItem.index,
            );
          });
      });
  }
}
